import Logo from '@/assets/logo.svg';

export default {
  data() {
    return {
      title: 'BMW',
      logo: {
        mobile: { url: Logo },
        desktop: { url: Logo },
      },
      isSticky: true,
      isStickyScroll: false,
      isVisible: true,
      scrollDirection: undefined, // false = down, true = up
      lastScrollPosition: 0,
      animationStart: undefined,
      animationLong: undefined,
      animationDuration: 300,
      height: {},
    };
  },
  watch: {
    scrollDirection() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      window.cancelAnimationFrame(this.animationLong);
      this.animationLong = undefined;
      this.animationStart = undefined;
      this.animationLong = window.requestAnimationFrame(this.animationHandler);
    },
  },
  mounted() {
    if (this.isStickyScroll) {
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
    }
  },
  beforeDestroy() {
    if (this.isStickyScroll) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
  },
  methods: {
    animationHandler(timestamp) {
      if (!this.animationStart) this.animationStart = timestamp;
      const progress = timestamp - this.animationStart;
      if (progress < this.animationDuration) {
        this.animationLong = window.requestAnimationFrame(
          this.animationHandler,
        );
        return;
      }
      this.isVisible = this.scrollDirection;
    },
    scrollHandler() {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      this.scrollDirection = currentScrollPosition < this.lastScrollPosition;
      this.isSearchVisible = currentScrollPosition <= 0;
      this.lastScrollPosition = currentScrollPosition;
    },
  },
};
